export default __webpack_public_path__ + "static/04-b75b7b978ff353fd89334ada16b2664c.jpg";